import { render, staticRenderFns } from "./InpatientReport.vue?vue&type=template&id=f7961d5c&"
import script from "./InpatientReport.vue?vue&type=script&lang=js&"
export * from "./InpatientReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports